/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriceConfirmationDto { 
    priceId: string;
    confirmedPrice: number;
    reason: PriceConfirmationDto.ReasonEnum;
    singleSupp?: number;
}
export namespace PriceConfirmationDto {
    export const ReasonEnum = {
        RecTooHigh: 'REC_TOO_HIGH',
        RecTooLow: 'REC_TOO_LOW',
        HierarchyIssue: 'HIERARCHY_ISSUE',
        MinMaxIssue: 'MIN_MAX_ISSUE',
        SingleIssue: 'SINGLE_ISSUE',
        HoldLivePrice: 'HOLD_LIVE_PRICE',
        YcDecision: 'YC_DECISION',
        YmDecision: 'YM_DECISION',
        Unforeseen: 'UNFORESEEN',
        ValueMisalignment: 'VALUE_MISALIGNMENT',
        SglSuppOnly: 'SGL_SUPP_ONLY',
        DemandIncrease: 'DEMAND_INCREASE',
        DemandDecrease: 'DEMAND_DECREASE'
    } as const;
    export type ReasonEnum = typeof ReasonEnum[keyof typeof ReasonEnum];
}


